<template>
  <span>{{ getMoneyFormat() }}</span>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    value: {
      default() {
        return 0;
      },
    },
    customCurrency: {
      default() {
        return null;
      },
    },
    formatPrice:{
      default(){
        return 'normal'; // normal, flash_sale
      }
    },
    isOntime:{
      default(){
        return '1';
      }
    }
  },
  computed: {
    ...mapGetters({
      module: "module",
    }),
    currenciesConverter() {
      return this.$store.getters[`${this.module}/page/currenciesConverter`];
    },
    currencyUse() {
      return this.$store.getters[`${this.module}/page/currencyUse`];
    },
    _currencyUse() {
      if (this.customCurrency == null) {
        return this.currencyUse;
      } else {
        return this.customCurrency;
      }
    },
    currencies() {
      return this.$store.getters[`${this.module}/page/currencies`];
    },
    multiplier() {
      return this.$store.getters[`${this.module}/page/multiplier`];
    },
    _multiplier() {
      if (this.customCurrency == null) {
        return this.multiplier;
      } else {
        return this.currenciesConverter[this.customCurrency.toUpperCase()]
          .multiplier;
      }
    },
    currencyDisplayType() {
      return this.currencies.currencyDisplay;
    },
    currency() {
      return this.currenciesConverter[this._currencyUse];
    },
    currencyCode() {
      return this.currency.code;
    },
    currencySymbol() {
      return this.currency.symbol;
    },
    countryCode() {
      return this.currency.countryCode;
    },
    isoLanguageCode() {
      return this.currency.isoLanguageCode.replace("_", "-");
    },
    moneyConvert() {
      return this.currencies.isEnableAutoConverter
        ? this.value * this._multiplier
        : this.value;
    },
  },
  methods: {
    getMoneyFormat() {
      let fullCurrencyText = new Intl.NumberFormat(this.isoLanguageCode, {
        style: "currency",
        currency: this.currencyCode,
        currencyDisplay: this.currencyDisplayType,
      }).format(this.moneyConvert);

      if (this.currencyDisplayType == "code") {
        let currencyCode = fullCurrencyText.match(/[^\d.,\s]+(?=\s|$)/)[0];
        currencyCode = currencyCode.replace(/\s/g, "");

        let money = fullCurrencyText
          .replace(/\s/g, "")
          .replace(currencyCode, "");

        if (money.endsWith(".00") || money.endsWith(",00")) {
          money = money.slice(0, -3); // remove the last 3 characters (".00")
        }
        if(this.isOntime == 0){
          money = this.formatPrice == 'flashsale' ? this.convertMoneyFormatCross(money) : money;
        }
        return money + " " + currencyCode;
      } else {
        let currencySymbol = fullCurrencyText.match(/[^\d.,\s]/)[0];
        currencySymbol = currencySymbol.replace(/\s/g, "");
        let money = fullCurrencyText
          .replace(/\s/g, "")
          .replace(currencySymbol, "");

        if (money.endsWith(".00") || money.endsWith(",00")) {
          money = money.slice(0, -3); // remove the last 3 characters (".00")
        }
        
        if(this.isOntime == 0){
          money = this.formatPrice == 'flashsale' ? this.convertMoneyFormatCross(money) : money;
        }
        return currencySymbol + "" + money;
      }
    },
    convertMoneyFormatCross(price) {
      price = price.replace(/,/g, '');
      const decimal = price.split('.')[1];
      const strPrice = price.toString().split('.')[0];
      const length = strPrice.length;
      
      let formatted = '';
      for (let i = 0; i < length; i++) {
        if(length == 1){
          formatted += 'X';
        }else if(length == 2){
          if (i === 1) {
                formatted += strPrice[i];
            } else {
                formatted += 'X';
            }
        }else{
          if (i === 0 || i === (length - 1)) {
              formatted += strPrice[i];
          } else {
              formatted += 'X';
          }
        }
      }
      if (decimal != null) {
        formatted = formatted +"."+ decimal
      }
      formatted = this.formatMoneyForString(formatted)
      return formatted;
    },
    formatMoneyForString(input) {
      let parts = input.split('.');
      let integerPart = parts[0];
      let decimalPart = parts.length > 1 ? '.' + parts[1] : '';

      let integerDigits = integerPart.length;
      let formattedInteger = '';

      for (let i = 0; i < integerDigits; i++) {
          let digit = integerPart[i];
          formattedInteger += digit;
          if ((integerDigits - i - 1) % 3 === 0 && i !== integerDigits - 1) {
              formattedInteger += ',';
          }
      }

      return formattedInteger + decimalPart;
    }
  },
};
</script>

<style></style>
